import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedDevolucionesAgregarFormularioXmlComponent {
  agregando = false
  coincide = false
  confirmarError = false
  confirmarReemplazo = false
  data
  mensajesError = []
  operadora
  onChange
  onDelete
  resultados = {}

  constructor ($fileSystem, ViaticosViaticoDevolucionesAgregarDecodificarService) {
    this.$fileSystem = $fileSystem
    this.parseViaticosViaticoDevolucionesAgregarDecodificarService = ViaticosViaticoDevolucionesAgregarDecodificarService
  }

  seleccionar () {
    this.$fileSystem.select(false, '.xml')
      .then((files) => (this.procesar(files)))
  }

  procesar (files) {
    if (this.agregando) return

    this.agregando = true
    const parse = this.parseViaticosViaticoDevolucionesAgregarDecodificarService.parse.bind(this.parseViaticosViaticoDevolucionesAgregarDecodificarService)

    parse(this.operadora.rfc, files[0], null)
      .then((resultados) => {
        this.resultados = resultados
        if (this.resultados.errores !== 0) {
          this.mensajesError = this.resultados.mensajes.filter((item) => item.estatus === 3)
          this.agregando = false
          this.confirmarError = true
        } else {
          this.validar()
        }
      })
  }

  validar () {
    let cData = Object.assign({}, this.data.data)

    delete cData.id_moneda
    delete cData.moneda
    delete cData.tipo_cambio

    if (Object.keys(cData).length) {
      this.coincide = Object.keys(this.resultados.data).every((key) => key === 'id_categoria' || key === 'notas'
        ? true : String(this.resultados.data[key]) === String(this.data.data[key]))
      if (this.coincide) {
        this.resultados.data['id_categoria'] = this.data.data['id_categoria']
        this.resultados.data['notas'] = this.data.data['notas']
        this.agregar(true)
      } else {
        if (this.resultados.data['tipo_devolucion'] !== this.data.data['tipo_devolucion']) {
          this.resultados.data['id_categoria'] = null
        }
        this.confirmarReemplazo = true
      }
    } else {
      this.agregar(true)
    }
  }

  agregar (reemplazar) {
    if (!reemplazar) {
      this.resultados = null
    }

    this.confirmarReemplazo = false
    this.agregando = false

    this.onChange({$event: {detail: this.resultados}})
  }

  eliminar () {
    this.onDelete()
  }
}

module.component('viaticosSharedDevolucionesAgregarFormularioXml', {
  controller: ViaticosSharedDevolucionesAgregarFormularioXmlComponent,
  template,
  bindings: {
    data: '<',
    operadora: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/devoluciones/agregar/formulario/xml/component.js